export const shortVideos = [
  {
    id: "s001",
    title: "深夜厨房：一碗热汤面",
    tag: "生活",
    duration: 252,
    uploadDate: "2025-09-28",
    views: 128400,
    creator: "夜航影像",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20night%20kitchen%20scene%20with%20a%20steaming%20bowl%20of%20noodle%20soup%20on%20a%20wooden%20counter%2C%20warm%20amber%20lamp%20glow%20against%20deep%20navy%20darkness%2C%20rising%20steam%20and%20chopsticks%2C%20cozy%20quiet%20midnight%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20fine%20film%20grain%2C%20no%20text%20and%20no%20lettering&width=640&height=360&seq=short-cover-01&orientation=landscape",
    intro: "凌晨两点半的厨房，只为一碗热汤面。水开的声音、葱花落进碗里的声音、以及终于坐下来的那一声叹气，都被完整地留在了这条片子里。",
  },
  {
    id: "s002",
    title: "电梯里的第十三层",
    tag: "剧情",
    duration: 158,
    uploadDate: "2025-09-21",
    views: 96200,
    creator: "暗场计划",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20short%20film%20frame%20of%20a%20dim%20elevator%20interior%20at%20midnight%20with%20reflective%20metal%20walls%20and%20a%20single%20amber%20ceiling%20light%2C%20floor%20indicator%20glowing%2C%20deep%20navy%20shadows%2C%20tense%20minimal%20composition%2C%20shallow%20depth%20of%20field%2C%20film%20grain%2C%20no%20text%20and%20no%20lettering&width=640&height=360&seq=short-cover-02&orientation=landscape",
    intro: "这栋写字楼的电梯只有十二层。可今晚，指示灯停在了十三。三分钟的单场景短片，用一部电梯讲完了所有不敢回头的瞬间。",
  },
  {
    id: "s003",
    title: "三分钟看完午夜悬疑片单",
    tag: "剪辑",
    duration: 185,
    uploadDate: "2025-09-15",
    views: 215000,
    creator: "午夜片单",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20montage%20style%20frame%20with%20overlapping%20dark%20film%20stills%20and%20moody%20navy%20blue%20light%20leaks%2C%20scattered%20film%20strips%20and%20amber%20glows%2C%20mysterious%20editorial%20collage%2C%20fine%20grain%2C%20shallow%20depth%20of%20field%2C%20no%20text%20and%20no%20lettering&width=640&height=360&seq=short-cover-03&orientation=landscape",
    intro: "剪了三十部适合深夜看的悬疑片，只保留最让人后背发凉的那几帧。片单在评论区，胆小的建议开灯观看。",
  },
  {
    id: "s004",
    title: "猫在凌晨三点叫醒我",
    tag: "搞笑",
    duration: 58,
    uploadDate: "2025-09-30",
    views: 342800,
    creator: "失眠事务所",
    cover: "https://readdy.ai/api/search-image?query=Playful%20cinematic%20frame%20of%20a%20curious%20cat%20sitting%20on%20a%20dark%20windowsill%20at%203am%2C%20warm%20amber%20lamp%20light%20and%20deep%20navy%20night%20outside%2C%20soft%20shadows%2C%20humorous%20candid%20mood%2C%20shallow%20depth%20of%20field%2C%20fine%20film%20grain%2C%20no%20text%20and%20no%20lettering&width=640&height=360&seq=short-cover-04&orientation=landscape",
    intro: "它每天凌晨三点准时踩我的脸，理由至今不明。后来我装了摄像头，才发现它是在叫我一起看楼下的流浪猫开会。",
  },
  {
    id: "s005",
    title: "城市霓虹延时摄影",
    tag: "生活",
    duration: 105,
    uploadDate: "2025-08-30",
    views: 176300,
    creator: "长曝光实验室",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20time%20lapse%20style%20frame%20of%20a%20wet%20city%20intersection%20at%20midnight%20with%20long%20light%20trails%20and%20glowing%20signage%2C%20deep%20navy%20and%20amber%20tones%2C%20reflections%20on%20asphalt%2C%20motion%20blur%2C%20atmospheric%20film%20grain%2C%20no%20text%20and%20no%20lettering&width=640&height=360&seq=short-cover-05&orientation=landscape",
    intro: "连续拍了十九个夜晚，只为了那条几乎没有人经过的斑马线。当所有车灯连成一条线，这座城市终于看起来像在呼吸。",
  },
  {
    id: "s006",
    title: "出租屋最后一晚",
    tag: "剧情",
    duration: 320,
    uploadDate: "2025-08-12",
    views: 88300,
    creator: "搬家日记",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20frame%20of%20an%20empty%20small%20rented%20room%20at%20midnight%20with%20cardboard%20boxes%20and%20a%20single%20floor%20lamp%2C%20pale%20amber%20light%20on%20bare%20walls%2C%20deep%20navy%20shadows%2C%20quiet%20nostalgic%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20film%20grain%2C%20no%20text%20and%20no%20lettering&width=640&height=360&seq=short-cover-06&orientation=landscape",
    intro: "在这间十二平米的房子里住了四年。搬走前的一晚，我把灯全部关掉，坐在门口听完了最后一个夜晚的声音。",
  },
  {
    id: "s007",
    title: "恐怖片里最不该做的五件事",
    tag: "剪辑",
    duration: 280,
    uploadDate: "2025-08-05",
    views: 194600,
    creator: "午夜片单",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20dark%20editorial%20frame%20of%20an%20old%20wooden%20door%20slightly%20open%20in%20a%20shadowy%20hallway%20at%20midnight%2C%20pale%20amber%20light%20spilling%20through%2C%20deep%20navy%20darkness%2C%20eerie%20minimal%20composition%2C%20film%20grain%2C%20no%20text%20and%20no%20lettering&width=640&height=360&seq=short-cover-07&orientation=landscape",
    intro: "不要独自进地下室，不要接没有来电显示的电话，不要回头看。剪了五十部恐怖片，总结出五条保命守则，第四条我至今不敢试。",
  },
  {
    id: "s008",
    title: "同事的午饭永远很神秘",
    tag: "搞笑",
    duration: 82,
    uploadDate: "2025-07-26",
    views: 268900,
    creator: "办公室观察员",
    cover: "https://readdy.ai/api/search-image?query=Humorous%20cinematic%20frame%20of%20an%20office%20pantry%20at%20night%20with%20a%20mysterious%20lunch%20box%20on%20the%20table%2C%20warm%20amber%20fridge%20light%20and%20deep%20navy%20shadows%2C%20playful%20suspenseful%20mood%2C%20shallow%20depth%20of%20field%2C%20film%20grain%2C%20no%20text%20and%20no%20lettering&width=640&height=360&seq=short-cover-08&orientation=landscape",
    intro: "他每天中午都带同一个饭盒，从不打开给我们看。直到某天他请假，我们才发现饭盒里装的是一整年份的电影票。",
  },
  {
    id: "s009",
    title: "深夜电台：给失眠的人",
    tag: "生活",
    duration: 370,
    uploadDate: "2025-07-18",
    views: 142700,
    creator: "零点频率",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20frame%20of%20a%20vintage%20radio%20and%20microphone%20in%20a%20dark%20studio%20at%20midnight%2C%20warm%20amber%20indicator%20lights%20and%20deep%20navy%20shadows%2C%20headphones%20on%20the%20desk%2C%20calm%20intimate%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20film%20grain%2C%20no%20text%20and%20no%20lettering&width=640&height=360&seq=short-cover-09&orientation=landscape",
    intro: "这是一段没有稿子的深夜电台。只有雨声、翻页声，和一句你可能等了很久的话：今天已经够辛苦了，睡吧。",
  },
  {
    id: "s010",
    title: "天台上的告白",
    tag: "剧情",
    duration: 213,
    uploadDate: "2025-07-09",
    views: 156200,
    creator: "夜航影像",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20romantic%20frame%20of%20two%20silhouettes%20standing%20apart%20on%20a%20rooftop%20at%20midnight%2C%20distant%20city%20lights%20and%20deep%20navy%20sky%2C%20warm%20amber%20glow%20from%20a%20stairwell%20door%2C%20gentle%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20film%20grain%2C%20no%20text%20and%20no%20lettering&width=640&height=360&seq=short-cover-10&orientation=landscape",
    intro: "他们在同一栋楼里住了三年，第一次说话是在天台。三分钟的短片，讲完了一句憋了三年的话，和一次没有结果的日出。",
  },
  {
    id: "s011",
    title: "一分钟反转结局",
    tag: "剧情",
    duration: 90,
    uploadDate: "2025-06-27",
    views: 231400,
    creator: "暗场计划",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20suspense%20frame%20of%20a%20hand%20holding%20an%20old%20photograph%20under%20a%20single%20warm%20lamp%20at%20midnight%2C%20deep%20navy%20background%20with%20soft%20bokeh%2C%20mysterious%20intimate%20composition%2C%20shallow%20depth%20of%20field%2C%20film%20grain%2C%20no%20text%20and%20no%20lettering&width=640&height=360&seq=short-cover-11&orientation=landscape",
    intro: "一分钟，一个房间，两个人，一句台词。看到最后一秒你才会明白，照片里那个被剪掉的人到底是谁。",
  },
  {
    id: "s012",
    title: "老电影色调调色教程",
    tag: "剪辑",
    duration: 435,
    uploadDate: "2025-06-14",
    views: 119800,
    creator: "胶片配方",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20editing%20desk%20scene%20at%20midnight%20with%20color%20grading%20monitor%20showing%20warm%20amber%20and%20deep%20navy%20film%20stills%2C%20film%20strips%20and%20notes%20on%20the%20desk%2C%20cozy%20dark%20studio%2C%20soft%20lamp%20light%2C%20shallow%20depth%20of%20field%2C%20film%20grain%2C%20no%20text%20and%20no%20lettering&width=640&height=360&seq=short-cover-12&orientation=landscape",
    intro: "把手机拍的夜景调成九十年代胶片感，只需要三步。全部参数都在视频里，附一份可直接套用的配方。",
  },
];